import React, { Component } from 'react';
import TransportsAtDTable from './TransportsAtDTable';


export class TransportsAtDContent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      content: this.props.showContent
    };
  }

  render() {

    return (
      <div>
        {this.state.content === 'transportsAtDestination' ?
          <TransportsAtDTable handleChangeContent={this.props.handleChangeContent.bind(this)} />
          : null
        }
      </div>
    )

  }
}

export default TransportsAtDContent;


// WEBPACK FOOTER //
// ./src/components/Transports/AtDestination/TransportsAtDContent.js